import { render, staticRenderFns } from "./UsdtBankForm.vue?vue&type=template&id=60bc992c&"
import script from "./UsdtBankForm.vue?vue&type=script&lang=ts&"
export * from "./UsdtBankForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports